import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { Menu } from '../../../interfaces/menu';
import * as _ from 'lodash';

declare function initSearchBar(): any;
declare function assignFunctionItemsSearchBar(element): any;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @ViewChild('itemsR') itemsR: ElementRef | undefined;
  itemsMenu: Array<Menu> = [];
  searching = false;
  activo = '';
  existContent = '';
  listado:any = [];
  textSearch:string = '';

  constructor(private menuService: MenuService) { }

  ngOnInit(): void {
    initSearchBar();
    this.itemsMenu = this.menuService.getMenu();
  }

  searchComponent(event:any):void {
    const filtro = event.target.value;
    this.listado = [];

    if (filtro.length > 0) {
      this.searching = true;
      this.search(filtro, event);
    } else {
      this.searching = false;
    }
  }

  search(filtro:string, e:any) {
    let lista:any = [];
    for (const categoria of this.itemsMenu) {
      const result = categoria.recursos.filter(componente => _.deburr(_.toLower(componente.nombreRecurso)).indexOf(_.deburr(_.toLower(filtro.trim()))) > -1);
      lista = lista.concat(result);
    }
    this.listado = lista;

    setTimeout(() => {
      assignFunctionItemsSearchBar(e.target);
    }, 100);
  }

  openItem(item:any) {
    this.searching = false;
  }
}
